/* eslint-disable no-unused-vars */
/** @module Auth0PostLoginHandlerExternalApp */
/* eslint-disable import/extensions */
import Auth0UtilsBrowser from '../../../../utils/auth0-utils-browser.mjs';
import Auth0PostLoginHandlerBase from '../auth0-post-login-handler-base.mst.mjs';
import Auth0Constants from '../../../../utils/auth0-constants.mjs';
import Auth0ExternalAppRegistry from '../../external-app-logins/auth0-external-app-config.mjs';
import Auth0TokenStorageHelper from '../auth0-token-storage-helper.mjs';

class Auth0PostLoginHandlerExternalApp extends Auth0PostLoginHandlerBase {
  constructor(options) {
    super(options);
    // optional, can be in Auth0Constants.AUTH0_EXTERNAL_APP_LOGIN_KEY cookie as well
    this._externalAppUrl = options.connectAppUrl;
    this._options = options;
  }

  _shouldHandleSync = (loginData) => {
    if (this.isDefault) return false;
    return !!this._externalAppId;
  };

  /**
   * @inheritdoc
   */
  async shouldHandle(loginData) {
    return Promise.resolve(this._shouldHandleSync(loginData));
  }

  /**
   * @inheritdoc
   */
  async run(loginData) {
    // for testing, set a cookie named Auth0Constants.AUTH0_EXTERNAL_APP_LOGIN_KEY that contains the url of the connect app
    // with value of shape: { externalAppId: 'ss-connect', launchUrl: 'https://the.launch.url }
    console.log('Auth0PostLoginHandlerExternalApp.run()...');

    // Store tokens in the default locations (legacy _lat and _latv3 cookies)
    if (loginData.tokens) {
      Auth0TokenStorageHelper.storeTokensDefault(loginData.tokens);
    }

    const externalLoginData = this._externalAppLoginRequestData;
    if (!externalLoginData) {
      throw new Error('Auth0PostLoginHandlerExternalApp is unable to run because no external app has been specified.');
    }

    const { externalAppId, launchUrl } = externalLoginData;
    console.log(`Auth0PostLoginHandlerExternalApp running login request for app ID "${externalAppId}"...`);
    const externalLoginUi = Auth0ExternalAppRegistry.appFromConfig(externalAppId, {
      externalAppId,
      externalAppUrl: launchUrl,
      tenantOrDomain: this._tenant.id,
      ...this._options,
    });
    await externalLoginUi.render();
  }

  get _externalAppLoginRequestData() {
    console.log(`[ExternalApp] _externalAppLoginRequestData: currentHref=${window.location.href}`);

    // getOption reads cookie first, then window.location.search QS param.
    // The QS path returns a raw string (parse=true only applies to the cookie path),
    // so parse manually when the result is a string.
    let data = Auth0UtilsBrowser.getOption(Auth0Constants.AUTH0_EXTERNAL_APP_LOGIN_KEY, false, true);
    if (typeof data === 'string') {
      try { data = JSON.parse(data); } catch { data = false; }
    }
    console.log(`[ExternalApp] getOption => ${JSON.stringify(data)}`);

    if (data) {
      console.log(`[ExternalApp] detected external app login, externalAppId="${data.externalAppId}"`);
      return data;
    }

    console.log('[ExternalApp] _externalAppLoginRequestData => false');
    return false;
  }

  get _externalAppId() {
    return this._externalAppLoginRequestData?.externalAppId;
  }
}

export default Auth0PostLoginHandlerExternalApp;
